module.exports = __webpack_public_path__ + "img/SoNs-2019-09.1060045a.jpg";